import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Environment} from '../../shared/environment/environment';
import {TvshopConstants} from '../../shared/tvshop-constants';
import {ActivatedRoute} from '@angular/router';
import {PageNames} from '../../shared/page-names.enum';
import {takeUntil} from 'rxjs/operators';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {NavigationService} from '../../services/navigation/navigation.service';
import {NavigableComponent} from '../../model/navigable-component';
import {Order} from '../../model/order';
import {TrialModalManagerComponent} from '../../modals/trial-modals/trial-modal-manager/trial-modal-manager.component';
import {TrialUtils} from '../../shared/utils/trial/trial-utils';
import {LanguageService} from '../../services/language/language.service';
import {DateUtil} from '../../shared/utils/Date/date-util';
import {Emitter} from '../../shared/utils/emitter/emitter';
import {EmitterConstants} from '../../shared/emitter-constants';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {AnalyticsService} from '../../services/analytics/analytics.service';
import {Trial} from '../../model/trial';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-trial-page',
  templateUrl: './trial-page.component.html',
  styleUrls: ['./trial-page.component.less']
})
export class TrialPageComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {
  runningTrials = [];
  omapiId: string;
  componentName = PageNames.TRIALS_PAGE;
  pack: TvShopEntertainmentPack;
  endDate: string;
  @ViewChild('trialcontent', {read: ElementRef})
  trialContentElement: ElementRef;

  @ViewChild('trialModal')
  trialModal: TrialModalManagerComponent;
  ownedPacks: Array<TvShopEntertainmentPack> = [];

  constructor(private route: ActivatedRoute,
              private changeDetector: ChangeDetectorRef,
              protected navigationService: NavigationService,
              private languageService: LanguageService,
              private stateService: TvShopStateService,
              private analyticsService: AnalyticsService) {
    super(navigationService);
  }

  ngOnInit() {
    this.navigationService.setCurrentPageComponent(PageNames.TRIALS_PAGE);
    this.getRunningTrial();
    this.subscribeToTrialActivation();
    this.analyticsService.onDetailPage([OmapiIdConstants.PLAY_SPORTS_TRIAL, OmapiIdConstants.PLAY_TRIAL, OmapiIdConstants.PLAY_MORE_TRIAL]);
  }

  ngOnDestroy() {
    this.navigationService.clearNavigation();
  }

  ngAfterViewInit() {
    this.navigationService.resetNavigation();
    this.changeDetector.detectChanges();
    this.navigationService.registerPageElement(this.trialContentElement);
  }

  public openTrialActivationModal(event: Order): void {
    Emitter.of(EmitterConstants.OPEN_INPUT_TRIAL_CODE_MODAL).emit(this.componentName);
  }

  public openFindTrialModal(): void {
    this.trialModal.showFindTrialModal(true);
  }

  public onBack(): void {
    this.trialModal.closeEventSubscriptions();
    this.navigationService.resetPage();
    this.navigationService.clearNavigation();
    this.routeOnBackPressed();
  }

  private routeOnBackPressed() {
    window.history.back();
  }

  public get trialsVisual(): string {
    return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + 'trials-visual.png';
  }

  public get backgroundImageUrl(): string {
    return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + 'trials-intro.jpg';
  }

  private baseUrl(): string {
    return Environment.environmentConfig().baseUrl;
  }

  public getLogoUrl(omapiId): string {
    return TrialUtils.getLogoUrlForTrialOmapiId(omapiId);
  }

  private getRunningTrial(): void {
    const packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    packs.filter(pack => pack.isTrial && pack.subscribed || pack.isDayPass && pack.subscribed).forEach(pack => {
      this.enrichRunningTrials(pack);
    });
    packs.filter(pack => pack.subscribed).forEach(pack => {
      this.ownedPacks.push(pack);
    });
  }

  private subscribeToTrialActivation() {
    Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL)
      .pipe(takeUntil(this.stopSubscription)).subscribe((trial: Trial) => {
      this.mapAndPushToRunningTrials(trial);
    });
  }

  private mapAndPushToRunningTrials(trial: Trial) {
    const isConversion = !!this.ownedPacks.filter(pack => pack.omapiId === trial.parentOmapiId).pop();

    this.runningTrials.push({
      omapiId: trial.omapiId,
      isTrial: true,
      logoUrl: this.getLogoUrl(trial.omapiId),
      endDate: DateUtil.getlocaleDate(DateUtil.getTrialEndDate(trial), this.languageService.getCurrentLanguage()),
      futureProduct: isConversion ? trial.parentOmapiId : undefined,
      futureProductName: isConversion ? OmapiIdConstants.PRODUCT_NAME_MAP.get(trial.parentOmapiId + '') : undefined
    });
  }

  private enrichRunningTrials(pack: TvShopEntertainmentPack): void {
    const isNotPresentOnArray = !this.runningTrials.filter(trial => trial.omapiId === pack.omapiId).pop();
    if (isNotPresentOnArray) {
      this.runningTrials.push({
        omapiId: pack.omapiId,
        futureProduct: pack.futureProduct,
        futureProductName: OmapiIdConstants.PRODUCT_NAME_MAP.get(pack.futureProduct + ''),
        isDayPass: pack.isDayPass,
        isTrial: pack.isTrial,
        logoUrl: this.getLogoUrl(pack.omapiId),
        endDate: DateUtil.getlocaleDate(pack.endDate, this.languageService.getCurrentLanguage()),
        largeLogo: (pack.omapiId === OmapiIdConstants.PLAY_TRIAL) ? 'play-trial-logo' : ''
      });
    }
  }

}
